import {Component, EventEmitter, Inject, Input, LOCALE_ID, OnInit, Output} from '@angular/core';
import {Observable} from 'rxjs';
import {AppUIParams} from '../../app.ui-params';
import {PlatformService} from '../../platform';
import {getLabelCategory, getSkillLabel, ProfessionalSkillModel} from '../../../../../functions/src/data';

@Component({
  selector: 'app-skill-item',
  templateUrl: './skill-item.component.html',
  styleUrls: ['./skill-item.component.scss']
})
export class SkillItemComponent implements OnInit {
  @Input() professionalSkill: ProfessionalSkillModel;
  @Input() hasRemoveButton = false;
  @Input() hasLevelSkill = true;
  @Output() skillRemoved = new EventEmitter<ProfessionalSkillModel>();

  // UI Params
  categoryIconColor: string;
  isMobile$: Observable<boolean>;

  constructor(@Inject(LOCALE_ID) protected localeId: string, private platform: PlatformService) {
  }

  ngOnInit() {
    this.categoryIconColor = AppUIParams.actionButtonOrangeBackgroundColor;
    this.isMobile$ = this.platform.isMobileSize(true);
  }

  /**
   * Get Label of category
   */
  getCategoryLabel() {
    if (this.professionalSkill) {
      return getLabelCategory(this.professionalSkill.category.id, this.localeId);
    } else {
      return '';
    }
  }

  /**
   * Get Label of a skill
   */
  getSkillLabel() {
    if (this.professionalSkill) {
      return getSkillLabel(this.professionalSkill.skill.id, this.localeId);
    } else {
      return '';
    }
  }

  onSkillRemove() {
    this.skillRemoved.emit(this.professionalSkill);
  }

}
